export const setDocumentTitle = function (title,desc,keywords) {
  document.title = title + ' - 会务通学术会议服务平台'
  // keywords && document.querySelector('meta[name="keywords"]').setAttribute('content',keywords) 
  // desc && document.querySelector('meta[name="description"]').setAttribute('content', desc)
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}
